<template>
  <div id="app">
    <error-display style="top: 100px;left: 50px; right: 50px;" />
    <eepos-header
      :fluid="showFluid"
      :username="user.name"
      :locale="$i18n.locale"
      :testing="isTestingSystem"
      :token="token"
      @logout-click="logout"
    >
      <router-link to="/">{{ $t('baseTitle') }}</router-link>
      <div class="subheader px-2" slot="subheader" >
        <router-view name="header" />
      </div>
    </eepos-header>
    <b-container fluid>
    <router-view class="view" name="app" />
    </b-container>
  </div>
</template>

<script>

import { cloak } from "./keecloak";

export default {
  data() {
    return {
      user: cloak._initialized && cloak.userInfo,
      token: null
    };
  },
  created(){
    this.token = cloak.token
    cloak.onTokenUpdate = (token) => {
      this.token = token
    }
  },
  methods: {
    logout() {
      cloak.logout();
    }
  },
  computed: {
    showFluid(){
      if (this.$route.name == "ProjectList" || this.$route.name == "shoppingCart")  return false
      return true
    },
    isTestingSystem() {
      return process.env.VUE_APP_IS_TEST_SYSTEM == "true";
    }
  }
}
</script>
<style lang="scss" scoped>
@import "styles/common";

#app {
  color: rgba(0, 0, 0, 0.8);
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.view {
  flex-grow: 1;
  min-height: 0;
  // overflow: auto;
}

#logo {
  height: 30px;
}

.go-back-link {
  width: 13em;
  margin-right: 40px;
  color: $eepos-blue !important;
  cursor: pointer;
}

.subheader {
  font-size: 14px;
}
</style>
